import { useMemo } from 'react';

import { useSelector } from 'src/hooks/useSelector';

import { CHAMELEON_COLUMNS } from 'src/components/VacancyView/brandingConstants';
import { useBranding } from 'src/components/VacancyView/hooks/useBranding';

// todo удалить HH-254627
const DEFAULT_COLUMN_PARAMS = {
    xs: '4',
    s: '8',
    m: '8',
    l: '10',
};

export const useContentColumns = (isRedisign) => {
    const { isChameleon } = useBranding();
    const showBrandedTemplateBorder = useSelector((state) => state.vacancyView.showBrandedTemplateBorder);

    const columnParam = useMemo(
        () => ({
            xs: '4',
            s: '8',
            m: isRedisign ? '12' : '8',
            l: '10',
        }),
        [isRedisign]
    );

    return useMemo(
        () =>
            showBrandedTemplateBorder
                ? { contentColumnParams: columnParam, bottomColumnParams: columnParam }
                : {
                      contentColumnParams: {
                          ...DEFAULT_COLUMN_PARAMS,
                          ...(isChameleon && CHAMELEON_COLUMNS),
                      },
                      bottomColumnParams: {
                          ...DEFAULT_COLUMN_PARAMS,
                          ...(isChameleon && CHAMELEON_COLUMNS),
                      },
                  },
        [isChameleon, showBrandedTemplateBorder, columnParam]
    );
};
